import { computed, ref, reactive, defineAsyncComponent } from 'vue'
import { RouteLocationNormalizedLoaded } from 'vue-router'
import ViewManager from '@/utils/ViewManager'
import { Views } from '@/store/views'
import { useStore } from 'vuex'

export default function ($route: RouteLocationNormalizedLoaded, dir = 'src', SHARED_VIEW_DIR = 'Shared') {
  const {
    views,
    resetView,
    showView,
    subModule,
    viewMode,
    activeViewModule,
    activeView,
    filters,
    activeViewName
  } = ViewManager.compose($route.name)

  const $store = useStore()

  // check if the view module has views loaded, and attempt to load them if not
  if (!views.value?.length) {
    // check if the given route has filters, and if so proactively add them
    // if not return the placeholder
    if ($route.meta && $route.meta?.filters) {
      $store.dispatch('View/Register', { routeName: $route.name, views: $route.meta.filters }).then(registered => {
        //
      }).catch(console.error)

      if (views.value[0]) showView(views.value[0])
    }
  }

  const windowWidth = window.innerWidth
  const windowHeight = window.innerHeight

  return {
    views,
    windowWidth,
    windowHeight,
    activeView,
    filters,
    activeViewName,
    showView,
    viewMode,
    // activeViewComponent: null,
    getActiveView: (resolver) => () => {
      if (!activeView.value) {
        if (!views.value?.length) return defineAsyncComponent(() => import('@/components/ViewPlaceholder.vue'))
        else showView(views.value[0])
      }
      return (activeView.value.startsWith(`${SHARED_VIEW_DIR}/`))
        ? resolver(`../${SHARED_VIEW_DIR}/${activeView.value.substring(SHARED_VIEW_DIR.length + 1)}`)
        : resolver(`./${activeView.value}`)
    },
    // NOTE -2 since length is 1 larget than the index value, and -1 to get the preceding index of the current route
    currentParent: computed(() => $route.matched[$route.matched.length - 2]),
    currentRoute: computed(() => $route.matched[$route.matched.length - 1])
  }
}
// `${pathToRoot}${dir}/${activeView.value}`
